import React, { useEffect, useState } from 'react';
import { AlertTriangle, Lock } from 'lucide-react';
import { useLanguage } from './LanguageContext';

interface ProtectionLayerProps {
  children: React.ReactNode;
}

const ProtectionLayer: React.FC<ProtectionLayerProps> = ({ children }) => {
  const [breachDetected, setBreachDetected] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    // 1. CONSOLE WARNING
    const showWarning = () => {
      const styleTitle = 'color: #39ff14; background: #000; font-size: 30px; padding: 10px; font-weight: bold; border: 2px solid #39ff14;';
      const styleMsg = 'color: #fff; background: #000; font-size: 16px; padding: 5px;';
      
      console.clear();
      console.log('%cSTOP! SECURE TERMINAL.%c', styleTitle, '');
      console.log('%cThis is a protected area. Your IP has been logged for security auditing. Copying source code is prohibited.', styleMsg);
    };
    showWarning();
    
    // 2. DISABLE RIGHT CLICK
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // 3. DISABLE SHORTCUTS
    const handleKeyDown = (e: KeyboardEvent) => {
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
        triggerDefense();
      }
      
      // Ctrl+Shift+I (DevTools), Ctrl+Shift+J (Console), Ctrl+Shift+C (Inspect)
      if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) {
        e.preventDefault();
        triggerDefense();
      }
      
      // Ctrl+U (View Source)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        triggerDefense();
      }

      // Ctrl+S (Save)
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
      }
    };

    const triggerDefense = () => {
      setBreachDetected(true);
      // Removed document.body.innerHTML = '' to fix the black screen issue.
      // Now React can correctly render the Lock screen below.
    };

    // Attach Event Listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  if (breachDetected) {
    return (
      <div className="fixed inset-0 bg-black flex flex-col items-center justify-center z-[9999] text-center p-4">
        <Lock size={64} className="text-red-500 mb-4 animate-pulse" />
        <h1 className="text-4xl md:text-6xl font-black text-red-500 mb-4 tracking-tighter">
          {t.protection.title}
        </h1>
        <div className="text-terminal-green font-mono text-lg space-y-2">
          <p>{t.protection.line1}</p>
          <p>{t.protection.line2}</p>
          <p>{t.protection.line3}</p>
        </div>
        <div className="mt-8 p-4 border border-red-500/30 bg-red-900/10 rounded">
          <p className="text-xs text-red-400 font-mono">
            {t.protection.error}
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectionLayer;